import React, { useState, useEffect } from 'react';
import { View, StyleSheet, LayoutChangeEvent } from 'react-native';
import { Dimensions } from 'react-native';
import { formatPrice } from '../utils/formatPrice';
import ReceiptPopup from '../components/ReceiptPopup';
import { Product, Category, OrderProduct, ProductVariant, OrderProductAddon, Order, ProductAddon, Floor, Combination, OrderCombination, Table, ProstayGuestDto, Customer } from '../interfaces';
import AddVariantsPopup from '../components/AddVariantsPopup';
import AddAddonsPopup from '../components/AddAddonsPopup';
import OrderOptionsPopup from '../components/OrderOptionsPopup';
import TableActionsPopup from '../components/TableActionsPopup';
import AddDiscountPopup from '../components/AddDiscountPopup';
import AddDiscountValue from '../components/AddDiscountValue';
import AddProductNotePopup from '../components/AddProductNotePopup';
import EditAddonsForProduct from '../components/EditAddonsForProduct';
import EditVariantsForProduct from '../components/EditVariantsForProduct';
import { useParams } from 'react-router-dom';
import AddOrderDiscountValue from '../components/AddOrderDiscountValue';
import SwipeableOrderItem from '../components/SwipeableOrderItem';
import SwipeableCombinationItem from '../components/SwipeableCombinationItem';
import './TableOrder.css';
import VoidedOrderErrorPopup from '../components/popups/VoidedOrderErrorPopup';
import { useNavigate } from 'react-router-dom';
import Spinner from '../components/Spinner';
import OrderCombinationOptionsMenu from '../components/OrderCombinationOptionsMenu';
import AddCombinationDiscountPopup from '../components/AddCombinationDiscountPopup';
import CashPaymentPopup from '../components/CashPaymentPopup';
import CardPaymentPopup from '../components/CardPaymentPopup';
import SelectReservationPopup from '../components/SelectReservationPopup';
import SelectCustomerPopup from '../components/SelectCustomerPopup';
import SuccessNotification from '../components/notifications/SuccessNotification';
import ErrorNotification from '../components/notifications/ErrorNotification';
import DeleteConfirmation from '../components/DeleteConfirmationPopup';
import { GUEST_CHECKED_OUT_TITLE, GUEST_CHECKED_OUT_TOAST_MS, readRoomChargeFailure } from '../services/roomChargeRefusal';


const loadSelectedFloorId = (setSelectedFloorId: (id: string) => void) => {
    const savedFloor = localStorage.getItem('selectedFloor');
    if (savedFloor) {
        const parsedFloor = JSON.parse(savedFloor);
        setSelectedFloorId(parsedFloor.value);
    }
};

const OrderView = () => {
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });
    const [products, setProducts] = useState<Product[]>([]);
    const [filteredProducts, setFilteredProducts] = useState<Product[]>([]);
    const [categories, setCategories] = useState<Category[]>([]);
    const [favorites, setFavorites] = useState<Product[]>([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedCategory, setSelectedCategory] = useState<Category>();
    const [orderProducts, setOrderProducts] = useState<OrderProduct[]>([]);
    const [isReceiptPopupOpen, setIsReceiptPopupOpen] = useState(false);
    const [selectedProductToAdd, setSelectedProductToAdd] = useState<Product | null>(null);
    const [isAddVariantOpen, setIsAddVariantOpen] = useState(false);
    const [isAddAddonOpen, setIsAddAddonOpen] = useState(false);
    const [isOrderOptionsOpen, setIsOrderOptionsOpen] = useState(false);
    const [optionsOpenedForProductIndex, setOptionsOpenedForProductIndex] = useState<number | null>(null);
    const [longPressTimeout, setLongPressTimeout] = useState<NodeJS.Timeout | null>(null);
    const [isTableActionsPopupOpen, setIsTableActionsPopupOpen] = useState(false);
    const [isAddDiscountPopupOpen, setIsAddDiscountPopupOpen] = useState(false);
    const [isAddDiscountValuePopupOpen, setIsAddDiscountValuePopupOpen] = useState(false);
    const [addingDiscountForProduct, setAddingDiscountForProduct] = useState<OrderProduct | null>(null);
    const [addingDiscountForProductIndex, setAddingDiscountForProductIndex] = useState<number | null>(null);
    const [addingNoteForProduct, setAddingNoteForProduct] = useState<OrderProduct | null>(null);
    const [addingAddonForProduct, setAddingAddonForProduct] = useState<OrderProduct | null>(null);
    const [addingVariantForProduct, setAddingVariantForProduct] = useState<OrderProduct | null>(null);
    const [activeOrder, setActiveOrder] = useState<Order>();
    const [isOrderDiscountOpen, setisOrderDiscountOpen] = useState(false);
    const [totalHeight, setTotalHeight] = useState<number | null>(null);
    const [emptyRowCount, setEmptyRowCount] = useState<number>(0);
    const [floor, setFloor] = useState<Floor | null>(null);
    const [selectedFloorId, setSelectedFloorId] = useState<string | null>(null);
    const [combinations, setCombinations] = useState<Combination[]>([]);
    const [isCombinationsSelected, setIsCombinationsSelected] = useState(false);
    const [showSpinner, setShowSpinner] = useState(false);
    const [isOrderCombinationsOptionsOpen, setIsOrderCombinationsOptionsOpen] = useState(false);
    const [optionsOpenedForCombinationIndex, setOptionsOpenedForCombinationIndex] = useState<number | null>(null);
    const [addingDiscountForCombination, setAddingDiscountForCombination] = useState<OrderCombination | null>(null);
    const [addingDiscountForCombinationIndex, setAddingDiscountForCombinationIndex] = useState<number | null>(null);
    const [addingNoteForCombination, setAddingNoteForCombination] = useState<OrderCombination | null>(null);
    const [isCashPopupOpen, setisCashPopupOpen] = useState(false);
    const [isCardPopupOpen, setisCardPopupOpen] = useState(false);
    const [emptyTables, setEmptyTables] = useState<Table[] | null>(null);
    const [isPutOnRoomOpen, setIsPutOnRoomOpen] = useState(false);
    const [isSelectCustomerOpen, setIsSelectCustomerOpen] = useState(false);
    const [successTitle, setSuccessTitle] = useState('');
    const [successContent, setSuccessContent] = useState('');
    const [showSuccess, setShowSuccess] = useState(false);
    const [errorTitle, setErrorTitle] = useState('');
    const [errorContent, setErrorContent] = useState('');
    const [showError, setShowError] = useState(false);
    const [showDeleteOrderConfirmation, setShowDeleteOrderConfirmation] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const fetchAvailableEmptyTablesForFloor = async (floorId: string) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/Floor/get-all-empty-tables-for-floor-id/` + floorId, {
                method: 'GET',
                credentials: 'include',
            });
            if (!response.ok) {
                throw new Error('Error fetching floor');
            }
            const data = await response.json();
            setEmptyTables(data);
        } catch (error) {
            console.error("Error fetching data: ", error);
        }
    };


    useEffect(() => {
        if (selectedFloorId) {
            setShowSpinner(true);
            fetchFloor(selectedFloorId);
            fetchAvailableEmptyTablesForFloor(selectedFloorId);
            setShowSpinner(false);

        }

    }, [selectedFloorId]);

    const handleConfirmPutOnRoomSelection = async (selectedRes: ProstayGuestDto | null) => {
        setIsPutOnRoomOpen(false);
        setIsReceiptPopupOpen(false);
        if (!activeOrder) return;

        try {
            setShowSpinner(true);

            const updatedOrder = { ...activeOrder, customerName: selectedRes?.firstName + " " + selectedRes?.lastName, customerEmail: selectedRes?.email };

            const response = await fetch(`${process.env.REACT_APP_API_URL}/Order/put-on-room`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    reservationNumber: selectedRes?.reservationNumber,
                    order: updatedOrder,
                }),
                credentials: 'include',
            });

            setShowSpinner(false);

            if (response.ok) {
                setSuccessTitle('Success!');
                setSuccessContent('Order was closed successfully. You will be redirected to the orders page.');
                setShowSuccess(true);

                setTimeout(() => {
                    setShowSuccess(false);
                    navigate('/orders');
                }, 3000);
            } else {
                const failure = await readRoomChargeFailure(response, 'Failed to close order');
                setErrorTitle(failure.checkedOut ? GUEST_CHECKED_OUT_TITLE : 'Error');
                setErrorContent(failure.message);
                setShowError(true);
                setTimeout(() => {
                    setShowError(false);
                }, failure.checkedOut ? GUEST_CHECKED_OUT_TOAST_MS : 3000);
            }
        } catch (error: any) {
            setShowSpinner(false);
            setErrorTitle('Unexpected Error');
            setErrorContent(error.message || 'Something went wrong while trying to close the order.');
            setShowError(true);
        }
    };

    const handleConfirmCustomerSelection = async (selectedCustomer: Customer | null) => {
        setIsSelectCustomerOpen(false);
        if (!activeOrder || !selectedCustomer) return;

        // Apply customer discounts to existing products
        const customerDiscounts = selectedCustomer.discounts || [];
        let updatedProducts = [...activeOrder.products];

        if (customerDiscounts.length > 0) {
            updatedProducts = updatedProducts.map(product => {
                // Skip products that already have a manual discount
                if (product.discount && product.discount > 0) return product;

                const matchingDiscount = customerDiscounts.find(d =>
                    d.applyToAll || (product.categoryId && d.categoryIds.includes(product.categoryId))
                );

                if (matchingDiscount) {
                    return {
                        ...product,
                        discount: matchingDiscount.value,
                        discountType: matchingDiscount.type === 'percentage' ? 'percentage' : 'amount'
                    };
                }
                return product;
            });
        }

        const updatedOrder = {
            ...activeOrder,
            customerName: `${selectedCustomer.firstName} ${selectedCustomer.lastName}`,
            customerEmail: selectedCustomer.email,
            customerId: selectedCustomer.id,
            customerDiscounts: customerDiscounts,
            products: updatedProducts
        };

        setActiveOrder(updatedOrder);

        try {
            await fetch(`${process.env.REACT_APP_API_URL}/Order/update`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(updatedOrder),
                credentials: 'include',
            });

            setSuccessTitle('Success!');
            setSuccessContent('Customer attached to order successfully.');
            setShowSuccess(true);
            setTimeout(() => setShowSuccess(false), 3000);
        } catch (error) {
            console.error('Error updating order with customer:', error);
        }
    };

    useEffect(() => {
        const handleStorageChange = (event: StorageEvent) => {
            if (event.key === 'selectedFloor') {
                loadSelectedFloorId(setSelectedFloorId);
            }
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    useEffect(() => {
        loadSelectedFloorId(setSelectedFloorId);
    }, []);

    const fetchFloor = async (floorId: string) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/Floor/` + floorId, {
                method: 'GET',
                credentials: 'include',
            });
            if (!response.ok) {
                throw new Error('Error fetching floor');
            }
            const data = await response.json();
            console.log(data);
            setFloor(data);
        } catch (error) {
            console.error("Error fetching data: ", error);
        }
    };


    const getTableNoById = (): string | null => {
        if (floor && floor.tables) {
            const table = floor.tables.find((t) => t.id === activeOrder?.tableId);
            return table ? table.tableNo : null;
        }
        return null;
    };

    const handleLayout = (event: LayoutChangeEvent) => {
        const { height } = event.nativeEvent.layout;
        setTotalHeight(height);
    };

    const { orderId } = useParams();

    const handleLongPress = (productIndex: number) => {
        setLongPressTimeout(setTimeout(() => {
            setIsOrderOptionsOpen(true);
            setOptionsOpenedForProductIndex(productIndex);
        }, 800));
    };

    const handleCombinationLongPress = (combinationIndex: number) => {
        setLongPressTimeout(setTimeout(() => {
            setIsOrderCombinationsOptionsOpen(true);
            setOptionsOpenedForCombinationIndex(combinationIndex);
        }, 800));
    };

    useEffect(() => {
        if (totalHeight !== null) {
            const screenHeight = Dimensions.get('window').height;
            const discountOffset = activeOrder?.orderDiscountValue ? 160 : 120;
            const emptySpace = screenHeight - 257 - totalHeight - discountOffset;
            const calculatedEmptyRows = Math.max(Math.floor(emptySpace / 40), 0);
            setEmptyRowCount(calculatedEmptyRows);
        }
    }, [totalHeight, activeOrder]);


    const handleAddNoteForProduct = (isProduct: boolean) => {
        if (isProduct) {
            if (optionsOpenedForProductIndex != null) {
                setAddingNoteForProduct(orderProducts[optionsOpenedForProductIndex]);
                setIsOrderOptionsOpen(false);
            }
        }
        else {
            if (optionsOpenedForCombinationIndex != null) {
                const selectedCombination = activeOrder?.combinations[optionsOpenedForCombinationIndex];
                if (selectedCombination) {
                    setAddingNoteForCombination(selectedCombination);
                } else {
                    setAddingNoteForCombination(null);
                }
                setIsOrderCombinationsOptionsOpen(false);
            }
        }
    }

    const handleAddAddonForProduct = () => {
        if (optionsOpenedForProductIndex != null) {
            setAddingAddonForProduct(orderProducts[optionsOpenedForProductIndex]);
            setIsOrderOptionsOpen(false);
        }
    }

    const handleAddVariantForProduct = () => {
        if (optionsOpenedForProductIndex != null) {
            setAddingVariantForProduct(orderProducts[optionsOpenedForProductIndex]);
            setIsOrderOptionsOpen(false);
        }
    }

    const closeAddNoteForProduct = () => {
        if (optionsOpenedForProductIndex != null) {
            setAddingNoteForProduct(null);
            setAddingNoteForCombination(null);
            setOptionsOpenedForProductIndex(null);
            setOptionsOpenedForCombinationIndex(null);
        }
    }

    const closeAddAddonForProduct = () => {
        if (optionsOpenedForProductIndex != null) {
            setAddingAddonForProduct(null);
            setOptionsOpenedForProductIndex(null);
        }
    }


    const closeAddVariantForProduct = () => {
        if (optionsOpenedForProductIndex != null) {
            setAddingVariantForProduct(null);
            setOptionsOpenedForProductIndex(null);
        }
    }


    const handleSaveNote = (note: string) => {
        if (optionsOpenedForProductIndex != null) {
            setOrderProducts((prevOrderProducts) => {
                if (prevOrderProducts.length === 0) return prevOrderProducts;
                const prod = prevOrderProducts[optionsOpenedForProductIndex];
                const updatedProduct = {
                    ...prod,
                    note: note,
                };

                const updatedProducts = prevOrderProducts.map((product, index) =>
                    index === optionsOpenedForProductIndex ? updatedProduct : product
                );

                if (activeOrder) {
                    const updatedOrder = {
                        ...activeOrder,
                        products: updatedProducts,
                    };
                    setActiveOrder(updatedOrder);
                    saveOrder(updatedOrder);
                }

                return prevOrderProducts.map((product, index) =>
                    index === optionsOpenedForProductIndex ? updatedProduct : product
                );
            });
        }
        else if (optionsOpenedForCombinationIndex != null) {
            setActiveOrder((prevActiveOrder) => {
                if (!prevActiveOrder || !prevActiveOrder.combinations) return prevActiveOrder;

                const combinationToUpdate = prevActiveOrder.combinations[optionsOpenedForCombinationIndex];

                const updatedCombination = {
                    ...combinationToUpdate,
                    note: note,
                };

                const updatedCombinations = prevActiveOrder.combinations.map((combination, index) =>
                    index === optionsOpenedForCombinationIndex ? updatedCombination : combination
                );

                const updatedActiveOrder = {
                    ...prevActiveOrder,
                    combinations: updatedCombinations,
                };

                saveOrder(updatedActiveOrder);

                return updatedActiveOrder;
            });
        }
        setOptionsOpenedForProductIndex(null);
        setOptionsOpenedForCombinationIndex(null);
        setAddingNoteForProduct(null);
        setAddingNoteForCombination(null);
    }
    const handleSaveAddonsForProduct = (addons: OrderProductAddon[]) => {
        if (optionsOpenedForProductIndex != null) {
            setOrderProducts((prevOrderProducts) => {
                if (prevOrderProducts.length === 0) return prevOrderProducts;
                const prod = prevOrderProducts[optionsOpenedForProductIndex];
                const updatedProduct = {
                    ...prod,
                    addons: addons,
                };

                const updatedProducts = prevOrderProducts.map((product, index) =>
                    index === optionsOpenedForProductIndex ? updatedProduct : product
                );

                if (activeOrder) {
                    const updatedOrder = {
                        ...activeOrder,
                        products: updatedProducts,
                    };
                    setActiveOrder(updatedOrder);
                    saveOrder(updatedOrder);
                }

                return prevOrderProducts.map((product, index) =>
                    index === optionsOpenedForProductIndex ? updatedProduct : product
                );
            });
        }
        setOptionsOpenedForProductIndex(null);
        setAddingAddonForProduct(null);
    }

    const handleSaveVariantForProduct = (variant: ProductVariant | null) => {
        if (optionsOpenedForProductIndex != null) {
            setOrderProducts((prevOrderProducts) => {
                if (prevOrderProducts.length === 0) return prevOrderProducts;
                const prod = prevOrderProducts[optionsOpenedForProductIndex];
                const updatedProduct = {
                    ...prod,
                    variants: variant != null ? [variant] : [],
                };

                const updatedProducts = prevOrderProducts.map((product, index) =>
                    index === optionsOpenedForProductIndex ? updatedProduct : product
                );

                if (activeOrder) {
                    const updatedOrder = {
                        ...activeOrder,
                        products: updatedProducts,
                    };
                    setActiveOrder(updatedOrder);
                    saveOrder(updatedOrder);
                }

                return prevOrderProducts.map((product, index) =>
                    index === optionsOpenedForProductIndex ? updatedProduct : product
                );
            });
        }
        setOptionsOpenedForProductIndex(null);
        setAddingVariantForProduct(null);
    }

    const handleCancelLongPress = () => {
        if (longPressTimeout) {
            clearTimeout(longPressTimeout);
        }
    };

    const handleCategoryClick = (category: Category) => {
        setSelectedCategory(category);
        setIsCombinationsSelected(false);
        const filtered = products.filter((product) => product.categoryName === category.name && product.name.toLowerCase().includes(searchTerm.toLowerCase()));
        setFilteredProducts(filtered);
    };

    const openReceipt = () => {
        setIsReceiptPopupOpen(true);
    }

    const getProductPriceValue = (orderProduct: OrderProduct) => {

        // A selected variant's price REPLACES the base product price (not additive).
        const pricedVariant = orderProduct.variants?.find(v => v?.priceWithoutTax != null && v.priceWithoutTax !== 0);
        let totalPrice = pricedVariant?.priceWithoutTax ?? orderProduct.price;

        orderProduct.addons.forEach(addon => {
            if (addon.addon.priceWithoutTax) {
                totalPrice = totalPrice + addon.addon.priceWithoutTax * addon.qty;
            }
        });

        if (orderProduct.discount && orderProduct.discount > 0) {
            if (orderProduct.discountType == "amount") {
                totalPrice = totalPrice - orderProduct.discount;
            }
            else if (orderProduct.discountType == "percentage") {
                totalPrice = totalPrice - ((orderProduct.discount / 100) * totalPrice);
            }
        }

        return totalPrice;
    };

    function generateGUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = (Math.random() * 16) | 0,
                v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }



    const handleProductClick = (prod: Product) => {
        const newOrderProduct: OrderProduct = {
            id: generateGUID(),
            qty: 1,
            name: prod.name,
            product: prod,
            discount: 0,
            note: '',
            addons: [],
            variants: [],
            discountType: '',
            plu: prod.plu,
            productId: prod.id,
            productName: prod.name,
            price: prod.price,
            sentToKitchen: false,
            taxRate: prod.taxRate,
            taxType: prod.taxType
        };
        const newProductList = [...orderProducts, newOrderProduct];
        setOrderProducts(newProductList);
        setSelectedProductToAdd(prod);

        if (prod.variants && prod.variants.length > 0) {
            setIsAddVariantOpen(true);
        }
        else if (prod.addons && prod.addons.length > 0) {
            setIsAddAddonOpen(true);
        }
        else {
            setSelectedProductToAdd(null);
        }

        if (activeOrder) {
            const updatedOrder = { ...activeOrder, products: newProductList };
            saveOrder(updatedOrder);
        }
    }

    const handleCombinationClick = async (comb: Combination) => {
        if (comb.type === 0) {
            const newOrderCombination: OrderCombination = {
                id: generateGUID(),
                combinationId: comb.id || '',
                combinationName: comb.name,
                combinationPlu: comb.combinationId || '',
                type: comb.type,
                price: comb.price,
                selectedsubproductsNames: [],
                selectedsubproductsIds: comb.subproducts ? comb.subproducts.map(subproduct => subproduct.id) : [],
                note: '',
                discount: 0,
                discountType: 'amount',
                sentToKitchen: false,
                taxRate: comb.taxRate,
                taxType: comb.taxType
            };

            if (activeOrder) {
                const updatedOrder = {
                    ...activeOrder,
                    combinations: [...(activeOrder.combinations || []), newOrderCombination],
                };
                setActiveOrder(updatedOrder);
                await saveOrder(updatedOrder);
            } else {
                console.error("activeOrder is undefined.");
            }
        } else {
            // Open combination popup
        }
    }

    const saveOrder = async (updatedOrder: Order) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/Order/update`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: updatedOrder.id,
                    propertyId: updatedOrder.propertyId,
                    products: updatedOrder.products,
                    customerEmail: updatedOrder.customerEmail,
                    customerName: updatedOrder.customerName,
                    customerId: updatedOrder.customerId,
                    seats: updatedOrder.seats,
                    currency: updatedOrder.currency,
                    subtotal: getSubtotal(),
                    total: getTotal(),
                    tax: getTax(),
                    isTaxPercentage: updatedOrder.isTaxPercentage,
                    discount: getDiscount(),
                    isOpen: updatedOrder.isOpen,
                    tableId: activeOrder?.tableId,
                    tableName: getTableNoById(),
                    orderDiscountType: updatedOrder.orderDiscountType,
                    orderDiscountValue: updatedOrder.orderDiscountValue,
                    status: updatedOrder.status,
                    orderNumber: updatedOrder.orderNumber,
                    waiter: updatedOrder.waiter,
                    date: updatedOrder.date,
                    closedBy: updatedOrder.closedBy,
                    createdBy: updatedOrder.createdBy,
                    orderPaidOn: updatedOrder.orderPaidOn,
                    isVoided: updatedOrder.isVoided,
                    combinations: updatedOrder.combinations,
                    subtotalWithoutDiscounts: updatedOrder.subtotalWithoutDiscounts
                }),
                credentials: 'include',
            });
            if (response) {

            }

        } catch (error) {
            //to do: display error
            console.error(error);
        }
    };

    // const payNowOrder = async () => {
    //     setShowSpinner(true);
    //     const fetchOrder = async () => {
    //         try {
    //             const response = await fetch(`${process.env.REACT_APP_API_URL}/Order/` + orderId, {
    //                 method: 'GET',
    //             });
    //             if (!response.ok) {
    //                 throw new Error('Network response was not ok');
    //             }
    //             const data = await response.json();

    //             const populatedOrderProducts = data.products.map((orderProduct: OrderProduct) => {
    //                 const product = products.find((p: Product) => p.id === orderProduct.productId);

    //                 const populatedAddons = orderProduct.addons.map((orderAddon: OrderProductAddon) => {
    //                     const addonDetails = product?.addons.find((prodAddon: ProductAddon) => prodAddon.id === orderAddon.addonId);
    //                     return {
    //                         ...orderAddon,
    //                         addon: addonDetails,
    //                     };
    //                 });

    //                 return {
    //                     ...orderProduct,
    //                     product: product || null,
    //                     addons: populatedAddons
    //                 };
    //             });

    //             setActiveOrder({
    //                 ...data,
    //                 products: populatedOrderProducts,
    //             });

    //             setOrderProducts(populatedOrderProducts);
    //             console.log(data);
    //         } catch (error) {
    //             console.error("Error fetching order: ", error);
    //         }
    //     };

    //     try {
    //         if (activeOrder) {
    //             const response = await fetch(`${process.env.REACT_APP_API_URL}/Order/finalize`, {
    //                 method: 'POST',
    //                 headers: { 'Content-Type': 'application/json' },
    //                 body: JSON.stringify({
    //                     id: activeOrder.id,
    //                     propertyId: activeOrder.propertyId,
    //                     products: activeOrder.products,
    //                     customerEmail: activeOrder.customerEmail,
    //                     customerName: activeOrder.customerName,
    //                     currency: activeOrder.currency,
    //                     subtotal: getSubtotal(),
    //                     total: getTotal(),
    //                     tax: getTax(),
    //                     isTaxPercentage: activeOrder.isTaxPercentage,
    //                     discount: getDiscount(),
    //                     isOpen: activeOrder.isOpen,
    //                     tableId: activeOrder.tableId,
    //                     tableName: getTableNoById(),
    //                     orderDiscountType: activeOrder.orderDiscountType,
    //                     orderDiscountValue: activeOrder.orderDiscountValue,
    //                     status: activeOrder.status,
    //                     orderNumber: activeOrder.orderNumber,
    //                     waiter: activeOrder.waiter,
    //                     date: activeOrder.date,
    //                     closedBy: activeOrder.closedBy,
    //                     createdBy: activeOrder.createdBy,
    //                     orderPaidOn: activeOrder.orderPaidOn,
    //                     isVoided: activeOrder.isVoided,
    //                     combinations: activeOrder.combinations,
    //                     subtotalWithoutDiscounts: activeOrder.subtotalWithoutDiscounts

    //                 }),
    //                 credentials: 'include',
    //             });
    //             if (response) {
    //                 await fetchOrder();
    //             }
    //         }

    //     } catch (error) {
    //         //to do: display error
    //         console.error(error);
    //     }
    //     finally {
    //         setShowSpinner(false);
    //     }
    // };

    const handleOnNextInVariant = () => {
        if (selectedProductToAdd?.addons && selectedProductToAdd?.addons.length > 0) {
            setIsAddVariantOpen(false);
            setIsAddAddonOpen(true);
        }
        else {
            setSelectedProductToAdd(null);
            setIsAddVariantOpen(false);
        }
    }

    const handleSaveAddons = (selectedAddons: OrderProductAddon[]) => {
        setOrderProducts((prevOrderProducts) => {
            if (prevOrderProducts.length === 0) return prevOrderProducts;

            const lastProduct = prevOrderProducts[prevOrderProducts.length - 1];

            const updatedProduct = {
                ...lastProduct,
                addons: selectedAddons,
            };

            const updatedProducts = [
                ...prevOrderProducts.slice(0, prevOrderProducts.length - 1),
                updatedProduct,
            ]

            if (activeOrder) {
                const updatedOrder = {
                    ...activeOrder,
                    products: updatedProducts,
                };
                setActiveOrder(updatedOrder);
                saveOrder(updatedOrder);
            }

            return [
                ...prevOrderProducts.slice(0, prevOrderProducts.length - 1),
                updatedProduct,
            ];
        });
        setSelectedProductToAdd(null);
        setIsAddAddonOpen(false);
    }

    const handleSelectedAmountDiscountForCombination = () => {
        console.log("optionsOpenedForCombinationIndex: " + optionsOpenedForCombinationIndex)
        if (optionsOpenedForCombinationIndex != null) {
            const selectedCombination = activeOrder?.combinations[optionsOpenedForCombinationIndex];
            if (selectedCombination) {
                console.log("if ")
                const updatedCombination = { ...selectedCombination, discountType: 'amount' };
                setAddingDiscountForCombination(updatedCombination);
                setAddingDiscountForCombinationIndex(optionsOpenedForCombinationIndex);
                setIsOrderCombinationsOptionsOpen(false);
            }
        }
    }

    const closeAddDiscountForCombination = () => {
        setAddingDiscountForCombination(null);
        setAddingDiscountForCombinationIndex(null);
    }

    const handleCombinationDiscountValueSaved = (value: number, discountType: string) => {
        if (addingDiscountForCombinationIndex != null) {
            const selectedCombination = activeOrder?.combinations[addingDiscountForCombinationIndex];
            if (selectedCombination) {
                const updatedCombination = { ...selectedCombination, discount: value, discountType: discountType };
                const updatedCombinations = [...activeOrder.combinations];
                updatedCombinations[addingDiscountForCombinationIndex] = updatedCombination;

                if (activeOrder) {
                    const updatedOrder = {
                        ...activeOrder,
                        combinations: updatedCombinations,
                    };
                    setActiveOrder(updatedOrder);
                    saveOrder(updatedOrder);
                }
            }
        }
        closeAddDiscountForCombination();
    }


    const handleVariantSelected = (variant: ProductVariant) => {
        setOrderProducts((prevOrderProducts) => {
            if (prevOrderProducts.length === 0) return prevOrderProducts;

            const lastProduct = prevOrderProducts[prevOrderProducts.length - 1];

            const updatedProduct = {
                ...lastProduct,
                variants: [...(lastProduct.variants || []), variant],
            };

            const updatedProducts = [
                ...prevOrderProducts.slice(0, prevOrderProducts.length - 1),
                updatedProduct,
            ]

            if (activeOrder) {
                const updatedOrder = {
                    ...activeOrder,
                    products: updatedProducts,
                };
                setActiveOrder(updatedOrder);
                saveOrder(updatedOrder);
            }

            return [
                ...prevOrderProducts.slice(0, prevOrderProducts.length - 1),
                updatedProduct,
            ];
        });

        if (selectedProductToAdd?.addons && selectedProductToAdd?.addons.length > 0) {
            setIsAddVariantOpen(false);
            setIsAddAddonOpen(true);
        }
        else {
            setSelectedProductToAdd(null);
            setIsAddVariantOpen(false);
        }
    }

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/Product`, {
                    method: 'GET',
                    credentials: 'include',
                });
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                setProducts(data);
                const filtered = data.filter((product: { name: string; }) =>
                    product.name.toLowerCase().includes(searchTerm.toLowerCase())
                );
                setFilteredProducts(filtered);
                setFavorites(data.filter((product: { isFavorite: boolean; }) => product.isFavorite));
            } catch (error) {
                console.error("Error fetching products: ", error);
            }
        };

        const fetchCategories = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/ProductCategory`, {
                    method: 'GET',
                    credentials: 'include',
                });
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                setCategories(data);
                setSelectedCategory(data[0]);
            } catch (error) {
                console.error("Error fetching categories: ", error);
            }
        };

        const fetchCombinations = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/Combination/get-all-active`, {
                    method: 'GET',
                    credentials: 'include',
                });
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                setCombinations(data);
            } catch (error) {
                console.error("Error fetching categories: ", error);
            }
        };

        const fetchData = async () => {
            setShowSpinner(true);
            await fetchProducts();
            await fetchCategories();
            await fetchCombinations();
            setShowSpinner(false);
        };

        fetchData();
    }, [searchTerm]);

    useEffect(() => {
        if (products.length === 0) return;

        const fetchOrder = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/Order/` + orderId, {
                    method: 'GET',
                    credentials: 'include',
                });
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();

                const populatedOrderProducts = data.products.map((orderProduct: OrderProduct) => {
                    const product = products.find((p: Product) => p.id === orderProduct.productId);

                    const populatedAddons = orderProduct.addons.map((orderAddon: OrderProductAddon) => {
                        const addonDetails = product?.addons.find((prodAddon: ProductAddon) => prodAddon.id === orderAddon.addonId);
                        return {
                            ...orderAddon,
                            addon: addonDetails,
                        };
                    });

                    return {
                        ...orderProduct,
                        product: product || null,
                        addons: populatedAddons
                    };
                });

                setActiveOrder({
                    ...data,
                    products: populatedOrderProducts,
                });

                setOrderProducts(populatedOrderProducts);
                console.log(data);
            } catch (error) {
                console.error("Error fetching order: ", error);
            }
        };

        const fetchData = async () => {
            setShowSpinner(true);
            await fetchOrder();
            setShowSpinner(false);
        };

        fetchData();
    }, [orderId, products]);

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setSearchTerm(value);
        const filtered = products.filter(product =>
            product.name.toLowerCase().includes(value.toLowerCase()) && product.categoryName === selectedCategory?.name
        );
        setFilteredProducts(filtered);
    };

    const handleAddDiscount = () => {
        setIsAddDiscountPopupOpen(true);
        setIsTableActionsPopupOpen(false);
    }

    const handleChangeTables = () => {
        console.log("available tables to select from:");
        console.log(emptyTables);
    }

    const handleDeleteOrderClick = () => {
        console.log("handleDeleteOrderClick called");
        setIsTableActionsPopupOpen(false);
        setShowDeleteOrderConfirmation(true);
    }

    const handleDeleteOrder = async () => {
        if (!activeOrder) return;

        try {
            setShowDeleteOrderConfirmation(false);
            setShowSpinner(true);
            const response = await fetch(`${process.env.REACT_APP_API_URL}/Order/delete/${activeOrder.id}`, {
                method: 'GET',
                credentials: 'include',
            });

            if (response.ok) {
                setSuccessTitle("Success!");
                setSuccessContent("Order was deleted successfully!");
                setShowSuccess(true);
                setShowSpinner(false);
                setTimeout(() => {
                    setShowSuccess(false);
                    navigate('/tables');
                }, 2000);
            } else {
                setShowSpinner(false);
                setErrorTitle("Error");
                setErrorContent("Failed to delete order. Please try again.");
                setShowError(true);
                setTimeout(() => {
                    setShowError(false);
                }, 3000);
            }
        } catch (error) {
            setShowSpinner(false);
            setErrorTitle("Error");
            setErrorContent("An error occurred while deleting the order.");
            setShowError(true);
            setTimeout(() => {
                setShowError(false);
            }, 3000);
        }
    }

    const openTableActions = () => {
        setIsTableActionsPopupOpen(true);
    }

    function getTextColorBasedOnBgColor(bgColor: string): string {
        if (!bgColor) return '#FFFFFF';

        const color = bgColor.startsWith('#') ? bgColor.slice(1) : bgColor;

        const r = parseInt(color.slice(0, 2), 16);
        const g = parseInt(color.slice(2, 4), 16);
        const b = parseInt(color.slice(4, 6), 16);

        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

        return luminance > 0.5 ? '#000000' : '#FFFFFF';
    }


    const getCombinationPriceValue = (combination: OrderCombination) => {

        let totalPrice = combination.price;

        if (combination.discount && combination.discount > 0) {
            if (combination.discountType == "amount") {
                totalPrice = totalPrice - combination.discount;
            }
            else if (combination.discountType == "percentage") {
                totalPrice = totalPrice - ((combination.discount / 100) * totalPrice);
            }
        }

        return totalPrice;
    };

    const getSubtotal = () => {
        const productsSubtotal = orderProducts.reduce((subtotal, ordProduct) => {
            return subtotal + (getProductPriceValue(ordProduct) * ordProduct.qty);
        }, 0);

        const combinationsSubtotal = (activeOrder?.combinations || []).reduce((subtotal, combination) => {
            return subtotal + getCombinationPriceValue(combination);
        }, 0);

        return productsSubtotal + combinationsSubtotal;
    }

    const getDiscount = () => {
        return orderProducts.reduce((totalDiscount, ordProduct) => {
            return totalDiscount + getDiscountValue(ordProduct) * ordProduct.qty;
        }, 0);
    }

    const getTax = () => {
        const productsTax = orderProducts.reduce((totalTax, ordProduct) => {
            if (!ordProduct.product) return totalTax;

            const { taxRate, taxType, price } = ordProduct.product;
            let taxAmount = taxType === 'percentage'
                ? (taxRate / 100) * price * ordProduct.qty
                : taxRate * ordProduct.qty;
            if (taxType === 'percentage') {
                taxAmount = parseFloat(taxAmount.toFixed(2));
            }
            return totalTax + taxAmount;
        }, 0);

        const combinationsTax = activeOrder?.combinations?.reduce((totalComboTax, combination) => {
            const { taxRate, taxType, price } = combination;
            let comboTaxAmount = taxType === 'percentage'
                ? (taxRate / 100) * price
                : taxRate;
            if (taxType === 'percentage') {
                comboTaxAmount = parseFloat(comboTaxAmount.toFixed(2));
            }
            return totalComboTax + comboTaxAmount;
        }, 0) || 0;

        return productsTax + combinationsTax;
    };


    const getTotal = () => {
        const subtotal = getSubtotal();
        const tax = getTax();
        const orderDiscount = getOrderDiscount() || 0;
        return subtotal + tax - orderDiscount;
    }

    const handleOverlayClick = () => {
        setSelectedProductToAdd(null);
        setIsAddAddonOpen(false);
        setIsAddVariantOpen(false);
    }

    const handleSelectedOrderDiscount = (discountType: string) => {
        if (activeOrder) {
            const updatedOrder: Order = {
                id: activeOrder.id ?? '',
                propertyId: activeOrder.propertyId ?? '',
                products: activeOrder.products ?? [],
                customerEmail: activeOrder.customerEmail ?? '',
                currency: activeOrder.currency ?? '',
                subtotal: activeOrder.subtotal ?? 0,
                total: activeOrder.total ?? 0,
                tax: activeOrder.tax ?? 0,
                isTaxPercentage: activeOrder.isTaxPercentage ?? false,
                discount: activeOrder.discount ?? 0,
                isOpen: activeOrder.isOpen ?? false,
                tableId: activeOrder.tableId ?? '',
                tableName: activeOrder.tableName ?? '',
                orderDiscountType: discountType,
                orderDiscountValue: activeOrder.orderDiscountValue ?? 0,
                status: activeOrder.status,
                orderNumber: activeOrder.orderNumber,
                customerName: activeOrder.customerName,
                // Rebuilt field-by-field, so anything omitted here is silently dropped
                // from the order. The customer link and the seats have to survive a discount.
                customerId: activeOrder.customerId,
                seats: activeOrder.seats,
                waiter: activeOrder.waiter,
                date: activeOrder.date,
                closedBy: activeOrder.closedBy,
                createdBy: activeOrder.createdBy,
                orderPaidOn: activeOrder.orderPaidOn,
                isVoided: activeOrder.isVoided,
                combinations: activeOrder.combinations,
                printer: null,
                mergedTablesIds: activeOrder.mergedTablesIds,
                mergedTablesNames: activeOrder.mergedTablesNames,
            };

            setActiveOrder(updatedOrder);
            setIsAddDiscountPopupOpen(false);
            setisOrderDiscountOpen(true);
            saveOrder(updatedOrder);
        }
    }

    const handleSaveOrderDiscountValue = (value: number, discountType: string) => {
        if (activeOrder) {
            const updatedOrder: Order = {
                id: activeOrder.id ?? '',
                propertyId: activeOrder.propertyId ?? '',
                products: activeOrder.products ?? [],
                customerEmail: activeOrder.customerEmail ?? '',
                customerName: activeOrder.customerName,
                customerId: activeOrder.customerId,
                seats: activeOrder.seats,
                currency: activeOrder.currency ?? '',
                subtotal: activeOrder.subtotal ?? 0,
                tax: activeOrder.tax ?? 0,
                isTaxPercentage: activeOrder.isTaxPercentage ?? false,
                discount: activeOrder.discount ?? 0,
                isOpen: activeOrder.isOpen ?? false,
                tableId: activeOrder.tableId ?? '',
                tableName: activeOrder.tableName ?? '',
                orderDiscountType: discountType,
                orderDiscountValue: value ?? 0,
                status: activeOrder.status,
                waiter: activeOrder.waiter,
                orderNumber: activeOrder.orderNumber,
                total: activeOrder.total ?? 0,
                date: activeOrder.date,
                closedBy: activeOrder.closedBy,
                createdBy: activeOrder.createdBy,
                orderPaidOn: activeOrder.orderPaidOn,
                isVoided: activeOrder.isVoided,
                combinations: activeOrder.combinations,
                printer: null,
                mergedTablesIds: activeOrder.mergedTablesIds,
                mergedTablesNames: activeOrder.mergedTablesNames,
            };

            setisOrderDiscountOpen(false);
            setActiveOrder(updatedOrder);
            saveOrder(updatedOrder);
        }

    }

    const handleSelectedProductAmountDiscount = (index: number | null) => {
        if (index != null) {
            if (index >= 0 && index < orderProducts.length) {
                const selectedProduct = orderProducts[index];

                const updatedProduct = { ...selectedProduct, discountType: 'amount' };
                setAddingDiscountForProduct(updatedProduct);
                setAddingDiscountForProductIndex(index);


                const updatedProducts = [...orderProducts];
                updatedProducts[index] = updatedProduct;

                if (activeOrder) {
                    const updatedOrder = {
                        ...activeOrder,
                        products: updatedProducts,
                    };
                    setActiveOrder(updatedOrder);
                    saveOrder(updatedOrder);
                }

                setOrderProducts(prevOrderProducts => {
                    const updatedOrderProducts = [...prevOrderProducts];
                    updatedOrderProducts[index] = updatedProduct;
                    return updatedOrderProducts;
                });
            } else {
                console.error('Invalid product index');
            }
            setIsAddDiscountValuePopupOpen(true);
            setIsOrderOptionsOpen(false);
            setIsAddDiscountPopupOpen(false);
        }
    }

    // const handleSelectedProductPercentageDiscount = (index: number) => {
    //     if (index >= 0 && index < orderProducts.length) {
    //         const selectedProduct = orderProducts[index];

    //         const updatedProduct = { ...selectedProduct, discountType: 'percentage' };
    //         setAddingDiscountForProduct(updatedProduct);
    //         setAddingDiscountForProductIndex(index);

    //         const updatedProducts = [...orderProducts];
    //         updatedProducts[index] = updatedProduct;

    //         if (activeOrder) {
    //             const updatedOrder = {
    //                 ...activeOrder,
    //                 products: updatedProducts,
    //             };
    //             setActiveOrder(updatedOrder);
    //             saveOrder(updatedOrder);
    //         }

    //         setOrderProducts(prevOrderProducts => {
    //             const updatedOrderProducts = [...prevOrderProducts];
    //             updatedOrderProducts[index] = updatedProduct;
    //             return updatedOrderProducts;
    //         });
    //     } else {
    //         console.error('Invalid product index');
    //     }
    //     setIsAddDiscountValuePopupOpen(true);
    //     setIsAddDiscountPopupOpen(false);
    // }

    const closeAddDiscountValuePopup = () => {
        setAddingDiscountForProduct(null);
        setAddingDiscountForProductIndex(null);
        setIsAddDiscountValuePopupOpen(false);
    }

    const handleDiscountValueSaved = (value: number, discountType: string) => {
        if (addingDiscountForProductIndex != null) {
            const selectedProduct = orderProducts[addingDiscountForProductIndex];
            const updatedProduct = { ...selectedProduct, discount: value, discountType: discountType };

            const updatedProducts = [...orderProducts];
            updatedProducts[addingDiscountForProductIndex] = updatedProduct;

            if (activeOrder) {
                const updatedOrder = {
                    ...activeOrder,
                    products: updatedProducts,
                };
                setActiveOrder(updatedOrder);
                saveOrder(updatedOrder);
            }

            setOrderProducts(prevOrderProducts => {
                const updatedOrderProducts = [...prevOrderProducts];
                updatedOrderProducts[addingDiscountForProductIndex] = updatedProduct;
                return updatedOrderProducts;
            });
        }
        closeAddDiscountValuePopup();
    }

    const calculateProductTotalPrice = (orderProduct: OrderProduct) => {
        // A selected variant's price REPLACES the base product price (not additive).
        const pricedVariant = orderProduct.variants?.find(v => v?.priceWithoutTax != null && v.priceWithoutTax !== 0);
        let totalPrice = pricedVariant?.priceWithoutTax ?? orderProduct.price;

        orderProduct.addons.forEach(addon => {
            if (addon.addon.priceWithoutTax) {
                totalPrice += addon.addon.priceWithoutTax * addon.qty;
            }
        });

        return totalPrice;
    };

    const getDiscountValue = (orderProduct: OrderProduct) => {
        if (orderProduct.discount && orderProduct.discount != 0) {
            const productTotalPrice = calculateProductTotalPrice(orderProduct);
            if (orderProduct.discountType == "amount")
                return orderProduct.discount;
            else if (orderProduct.discountType == "percentage")
                return (orderProduct.discount / 100) * productTotalPrice;
        }
        return 0;
    }

    const getOrderDiscount = () => {
        if (activeOrder) {
            let discount = 0;
            if (activeOrder.orderDiscountType == "percentage") {
                const subtotal = getSubtotal();
                discount = (activeOrder.orderDiscountValue / 100) * subtotal;
                discount = parseFloat(discount.toFixed(2));
                return discount;
            }
            else if (activeOrder.orderDiscountType == "amount") {
                return activeOrder.orderDiscountValue;
            }
        }
    }

    const handleRemoveProductFromOrder = (index: number) => {
        const newProductList = orderProducts.filter((_, i) => i !== index);
        setOrderProducts(newProductList);
        if (activeOrder) {
            const updatedOrder = { ...activeOrder, products: newProductList };
            setActiveOrder(updatedOrder);
            saveOrder(updatedOrder);
        }
    }

    const handleDeleteCombination = (index: number) => {
        const newCombinations = activeOrder?.combinations.filter((_, i) => i !== index);
        if (activeOrder && newCombinations) {
            const updatedOrder = { ...activeOrder, combinations: newCombinations };
            setActiveOrder(updatedOrder);
            saveOrder(updatedOrder);
        }
    };

    const [showDeleteOrder, setShowDeleteOrder] = useState<{ [key: number]: boolean }>({});
    const [swipedDistanceOrder, setSwipedDistanceOrder] = useState(0);

    const [showDeleteCombination, setShowDeleteCombination] = useState<{ [key: number]: boolean }>({});
    const [swipedDistanceCombination, setSwipedDistanceCombination] = useState(0);
    const [showVoidedOrderErrorPopup, setShowVoidedOrderErrorPopup] = useState(false);

    const resetShowDeleteOrder = () => setShowDeleteOrder({});
    const resetShowDeleteCombination = () => setShowDeleteCombination({});
    const navigate = useNavigate();

    const handleTransferProduct = () => {

    }

    const handleMergeTables = () => {

        setIsTableActionsPopupOpen(false);
    }

    useEffect(() => {
        const backButton = document.getElementById('tables-back-btn');

        if (backButton) {
            const handleButtonClick = () => {
                if (activeOrder?.status == 2) { //if order is voided
                    console.log('Order is voided cant go back');
                    setShowVoidedOrderErrorPopup(true);

                    setTimeout(() => {
                        setShowVoidedOrderErrorPopup(false);
                    }, 5000);
                }
                else {
                    navigate('/tables')
                }
            };

            backButton.addEventListener('click', handleButtonClick);

            return () => {
                backButton.removeEventListener('click', handleButtonClick);
            };
        }
    }, [activeOrder, navigate]);

    const [selectedProductIds, setSelectedProductIds] = useState<string[]>([]);
    const [selectedCombinationIds, setSelectedCombinationIds] = useState<string[]>([]);

    const handleToggleCheckbox = (productId: string) => {
        setSelectedProductIds((prevState) =>
            prevState.includes(productId)
                ? prevState.filter((id) => id !== productId)
                : [...prevState, productId]
        );
    };

    const handleToggleCheckboxForCombination = (combinationId: string) => {
        setSelectedCombinationIds((prevState) =>
            prevState.includes(combinationId)
                ? prevState.filter((id) => id !== combinationId)
                : [...prevState, combinationId]
        );
    };

    const styles = StyleSheet.create({
        container: {
            flex: 1,
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            paddingLeft: 15,
            flexDirection: 'row',
            display: 'flex',
            height: windowSize.height - 55,
            overflow: 'hidden'
        },
        productsContainer: {
            width: windowSize.width * 0.6 - 100,
        },
        productsContainerList: {
            height: windowSize.height - 212,
            display: 'flex',
            flexDirection: 'row',
            gap: 10,
            flexWrap: 'wrap',
            alignItems: 'flex-start',
            maxWidth: '100%',
            alignContent: 'flex-start'
        },
        orderProductsContainer: {
            height: windowSize.height - 277,
        },
        categoriesList: {
            maxWidth: '100%'
        },
        searchInputContainer: {
            display: 'flex',
            alignItems: 'center',
            borderWidth: 1,
            borderColor: '#D0D5DD',
            borderStyle: 'solid',
            paddingLeft: 5,
            height: 30
        },
        iconContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            paddingRight: 8
        },
        favoritesContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            height: windowSize.height - 162,
        },
        orderContainer: {
            display: 'flex',
            flexDirection: 'column',
            width: windowSize.width * 0.4,
            height: windowSize.height - 52,
        },
        emptyRow: {
            height: 40,
            color: 'transparent'
        },
        grayRow: {
            backgroundColor: '#F9FAFB',
        },
        whiteRow: {
            backgroundColor: '#ffffff',
        },
        overlay: {
            backgroundColor: 'rgba(51, 51, 51, 0.6)',
            height: windowSize.height,
            width: windowSize.width,
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 10
        },
        searchContainer: {
            position: 'relative',
        },
        searchInput: {
            borderColor: '#D0D5DD',
            borderStyle: 'solid',
            borderWidth: 1,
            paddingLeft: 30,
            width: '45%',
            minWidth: 150
        },
        searchIcon: {
            position: 'absolute',
            left: 10,
            top: 15
        }
    });



    return (
        <View style={{ ...styles.container, overflow: 'hidden' }}>
            <div className='d-flex flex-column'>
                <div className='d-flex'>
                    <div style={styles.productsContainer}>
                        <div className='px-0 py-2' style={{ ...styles.searchContainer }}>
                            <input
                                style={styles.searchInput}
                                type="text"
                                value={searchTerm}
                                onChange={handleSearchChange}
                                placeholder="Search products"
                            />
                            <svg width="15" height="15" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={styles.searchIcon}>
                                <path d="M16.5002 16.5002L12.881 12.881M12.881 12.881C13.5001 12.2619 13.9912 11.527 14.3262 10.7181C14.6612 9.90927 14.8337 9.04234 14.8337 8.16684C14.8337 7.29134 14.6612 6.42441 14.3262 5.61555C13.9912 4.80669 13.5001 4.07174 12.881 3.45267C12.2619 2.8336 11.527 2.34252 10.7181 2.00748C9.90927 1.67244 9.04234 1.5 8.16684 1.5C7.29134 1.5 6.42441 1.67244 5.61555 2.00748C4.80669 2.34252 4.07174 2.8336 3.45267 3.45267C2.2024 4.70295 1.5 6.39868 1.5 8.16684C1.5 9.93499 2.2024 11.6307 3.45267 12.881C4.70295 14.1313 6.39868 14.8337 8.16684 14.8337C9.93499 14.8337 11.6307 14.1313 12.881 12.881Z" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div style={{ ...styles.productsContainerList, overflowY: 'scroll' }} className="hide-scrollbar">
                            {
                                <>
                                    {
                                        !isCombinationsSelected &&
                                        filteredProducts.map((prod) =>
                                            <div className='product' onClick={() => handleProductClick(prod)} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', backgroundColor: prod.color ? prod.color : '#1643E0', color: getTextColorBasedOnBgColor(prod.color), borderRadius: '5px', padding: '10px' }}>
                                                <span style={{ fontSize: '14px', fontWeight: '500', fontFamily: 'Inter' }}>{prod.name}</span>
                                                <div className='d-flex justify-content-end'>
                                                    <span style={{ fontSize: '14px', fontWeight: '500', fontFamily: 'Inter' }}>{formatPrice(prod.price)}</span>
                                                </div>
                                            </div>)
                                    }
                                    {
                                        isCombinationsSelected &&
                                        combinations.map((comb) =>
                                            <div className='product' onClick={() => handleCombinationClick(comb)} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', backgroundColor: '#FEF0C7', color: '#333333', borderRadius: '5px', padding: '10px' }}>
                                                <span style={{ fontSize: '14px', fontWeight: '500', fontFamily: 'Inter' }}>{comb.name}</span>
                                                <div className='d-flex justify-content-end'>
                                                    <span style={{ fontSize: '14px', fontWeight: '500', fontFamily: 'Inter' }}>{formatPrice(comb.price)}</span>
                                                </div>
                                            </div>
                                        )
                                    }
                                </>
                            }
                        </div>
                    </div>
                    <div style={{ ...styles.favoritesContainer }} className='px-2'>
                        <h6 className='pt-3 m-0'>Favorites</h6>
                        <div style={{ overflowY: 'scroll', height: windowSize.height - 205 }} className='d-flex flex-column gap-2 hide-scrollbar'>
                            {
                                favorites.map((fav) =>
                                    <div className='product' onClick={() => handleProductClick(fav)} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', backgroundColor: '#F2F4F7', color: '#333333', borderRadius: '5px', padding: '10px' }}>
                                        <span style={{ fontSize: '14px', fontWeight: '500', fontFamily: 'Inter' }}>{fav.name}</span>
                                        <div className='d-flex justify-content-end'>
                                            <span style={{ fontSize: '14px', fontWeight: '500', fontFamily: 'Inter' }}>{formatPrice(fav.price)}</span>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
                <div style={{ ...styles.categoriesList, overflowX: 'scroll', borderTop: '1px solid #F4F4F4' }} className='d-flex gap-2 py-2 pb-0 hide-scrollbar'>
                    <div onClick={() => { setIsCombinationsSelected(true); setSelectedCategory(undefined) }} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-around', alignItems: 'center', gap: '5px', height: '90px', width: '90px', backgroundColor: isCombinationsSelected ? '#1643E0' : '#F4F4F4', color: isCombinationsSelected ? '#ffffff' : '#000000', borderRadius: '5px', padding: '10px', minWidth: '90px' }}>
                        <svg width="42" height="42" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="24.5" cy="24.5" r="24.5" fill="#1643E0" />
                            <path d="M24.808 11.2196C24.2975 10.9763 23.7045 10.9763 23.1941 11.2196C22.7528 11.43 22.5095 11.7953 22.3868 11.9957C22.26 12.2029 22.1298 12.4668 22.0028 12.7241L19.3082 18.1832L13.2806 19.0642C12.9969 19.1056 12.7057 19.1481 12.4696 19.2049C12.2411 19.2598 11.8188 19.3786 11.4826 19.7334C11.0938 20.1439 10.9109 20.7079 10.9849 21.2684C11.0489 21.753 11.3212 22.097 11.4739 22.2756C11.6318 22.4601 11.8427 22.6654 12.0481 22.8654L16.4079 27.1118L15.3791 33.1096C15.3306 33.3924 15.2808 33.6825 15.2616 33.9248C15.243 34.159 15.2251 34.5977 15.4585 35.0273C15.7284 35.5243 16.2083 35.8729 16.7644 35.976C17.2451 36.0651 17.6567 35.9124 17.8738 35.8224C18.0982 35.7293 18.3587 35.5922 18.6127 35.4586L24.001 32.6249L29.3894 35.4586C29.6433 35.5922 29.9038 35.7293 30.1282 35.8224C30.3453 35.9124 30.7569 36.0651 31.2377 35.976C31.7937 35.8729 32.2736 35.5243 32.5435 35.0273C32.7769 34.5977 32.759 34.159 32.7404 33.9248C32.7212 33.6826 32.6714 33.3925 32.6229 33.1097L31.5942 27.1118L35.954 22.8654C36.1594 22.6653 36.3702 22.4601 36.5281 22.2756C36.6808 22.097 36.9531 21.753 37.0171 21.2684C37.0911 20.7079 36.9083 20.1439 36.5194 19.7334C36.1833 19.3786 35.7609 19.2598 35.5324 19.2049C35.2963 19.1481 35.0051 19.1056 34.7214 19.0642L28.6938 18.1832L25.9992 12.7241C25.8723 12.4669 25.7421 12.2029 25.6152 11.9957C25.4925 11.7953 25.2492 11.43 24.808 11.2196Z" fill="white" />
                        </svg>
                        <span style={{ fontSize: '12px', fontWeight: '500', fontFamily: 'Inter' }}>Combinations</span>
                    </div>
                    {
                        categories.map((cat) =>
                            <div onClick={() => handleCategoryClick(cat)} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-around', alignItems: 'center', gap: '5px', height: '90px', width: '90px', backgroundColor: selectedCategory?.name == cat.name ? '#1643E0' : '#F4F4F4', color: selectedCategory?.name == cat.name ? '#ffffff' : '#000000', borderRadius: '5px', padding: '10px', minWidth: '90px' }}>
                                <img src={cat.imageUrl} style={{ height: '42px', width: '42px' }} />
                                <span style={{ fontSize: '12px', fontWeight: '500', fontFamily: 'Inter' }}>{cat.name}</span>
                            </div>
                        )
                    }
                </div>
            </div>

            <div style={{ ...styles.orderContainer, borderLeft: '1px solid #EAECF0' }}>
                <div className='d-flex pt-3 px-2 align-items-center justify-content-between' style={{ backgroundColor: '#F9FAFB', flexWrap: 'wrap' }}>
                    <span style={{ color: '#1643E0', fontWeight: '600', fontFamily: 'Inter', fontSize: '14px', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}> {activeOrder?.tableName || getTableNoById()} {activeOrder?.customerName ? "(" + activeOrder?.customerName + (activeOrder?.roomNumber ? " - " + activeOrder?.roomNumber : "") + ")" : ""}</span>
                    <span style={{ color: '#475467', fontWeight: '600', fontFamily: 'Inter', fontSize: '14px' }}>24/08/17 10:26</span>
                </div>
                <div className='d-flex gap-0' style={{ borderTop: '1px solid #EAECF0', }}>
                    <div className='col p-2' style={{ backgroundColor: '#EAECF0' }}>
                        <span style={{ fontSize: '14px', fontWeight: '500' }}>ID</span>
                    </div>
                    <div className='col py-2' style={{ backgroundColor: '#EAECF0' }}>
                        <span style={{ fontSize: '14px', fontWeight: '500' }}>QTY</span>
                    </div>
                    <div className='col-6 py-2 ' style={{ backgroundColor: '#EAECF0' }}>
                        <span style={{ fontSize: '14px', fontWeight: '500' }}>Product Name</span>
                    </div>
                    <div className='col py-2 d-flex justify-content-end' style={{ backgroundColor: '#EAECF0', paddingRight: 10 }}>
                        <span style={{ fontSize: '14px', fontWeight: '500' }}>Price</span>
                    </div>
                </div>

                <div style={{ ...styles.orderProductsContainer, overflowY: 'scroll', overflowX: 'hidden' }} className="hide-scrollbar">
                    {

                        <View onLayout={handleLayout}>
                            {orderProducts && orderProducts.length > 0 && (
                                <>
                                    {orderProducts.map((prod, index) =>
                                        <>
                                            <SwipeableOrderItem prod={prod} index={index} showDelete={showDeleteOrder} key={index} setShowDelete={setShowDeleteOrder}
                                                swipedDistance={swipedDistanceOrder}
                                                setSwipedDistance={setSwipedDistanceOrder}
                                                handleLongPress={handleLongPress}
                                                handleCancelLongPress={handleCancelLongPress}
                                                onDelete={handleRemoveProductFromOrder}
                                                resetShowDeleteCombination={resetShowDeleteCombination}
                                                displayCheckbox={isOrderOptionsOpen}
                                                onToggleCheckbox={() =>
                                                    handleToggleCheckbox(prod.id)
                                                }
                                                checkboxState={selectedProductIds.includes(prod.id)}
                                                mealPlanStatus={(prod as any).mealPlanStatus}
                                                backgroundColor={index % 2 === 0 ? '#ffffff' : '#F9FAFB'}

                                            />
                                        </>
                                    )}
                                </>
                            )}
                            {activeOrder?.combinations && activeOrder.combinations.length > 0 && (
                                <>
                                    {activeOrder.combinations.map((comb, index) => (
                                        <SwipeableCombinationItem
                                            key={index}
                                            comb={comb}
                                            index={index}
                                            showDelete={showDeleteCombination}
                                            setShowDelete={setShowDeleteCombination}
                                            swipedDistance={swipedDistanceCombination}
                                            setSwipedDistance={setSwipedDistanceCombination}
                                            handleLongPress={handleCombinationLongPress}
                                            handleCancelLongPress={handleCancelLongPress}
                                            onDelete={handleDeleteCombination}
                                            resetShowDeleteOrder={resetShowDeleteOrder}
                                            displayCheckbox={isOrderOptionsOpen}
                                            onToggleCheckbox={() =>
                                                handleToggleCheckboxForCombination(comb.id)
                                            }
                                            checkboxState={selectedCombinationIds.includes(comb.id)}
                                        />
                                    ))}
                                </>
                            )}
                        </View>


                    }
                    {Array.from({ length: emptyRowCount }, (_, index) => (
                        <div
                            key={index}
                            style={{
                                ...styles.emptyRow,
                                ...((index + products.length) % 2 === 0 ? styles.grayRow : styles.whiteRow), borderTop: '1px solid #EAECF0'
                            }}
                        >

                            <div className='col-2' style={{ borderRight: '1px solid #EAECF', height: '100%' }}>
                                Row
                            </div>
                        </div>
                    ))}
                    <div className='d-flex justify-content-between gap-0' style={{ borderTop: '1px solid #F4F4F4' }}>
                        <div className='col p-2' style={{ backgroundColor: '#fff' }}>
                            <span style={{ fontSize: '14px' }}>Subtotal</span>
                        </div>
                        <div className='col-auto px-2 py-2' style={{ backgroundColor: '#fff' }}>
                            <span style={{ fontSize: '14px', textAlign: 'end', display: 'flex', justifyContent: 'end' }}>{formatPrice(getSubtotal())}</span>
                        </div>
                    </div>
                    {
                        (activeOrder?.orderDiscountValue && activeOrder?.orderDiscountValue > 0) ?
                            <div className='d-flex justify-content-between gap-0' style={{ borderTop: '1px solid #F4F4F4' }}>
                                <div className='col p-2' style={{ backgroundColor: '#fff' }}>
                                    <span style={{ fontSize: '14px' }}>Discount {activeOrder?.orderDiscountType == "percentage" ? "(" + activeOrder?.orderDiscountValue + "%)" : ""}</span>
                                </div>
                                <div className='col-auto px-2 py-2' style={{ backgroundColor: '#fff' }}>
                                    <span style={{ fontSize: '14px', textAlign: 'end', display: 'flex', justifyContent: 'end' }}>{formatPrice(getOrderDiscount())}</span>
                                </div>
                            </div>
                            :
                            <>
                            </>
                    }
                    <div className='d-flex justify-content-between gap-0' style={{ borderTop: '1px solid #F4F4F4' }}>
                        <div className='col p-2' style={{ backgroundColor: '#fff' }}>
                            <span style={{ fontSize: '14px' }}>Tax</span>
                        </div>
                        <div className='col-auto px-2 py-2' style={{ backgroundColor: '#fff' }}>
                            <span style={{ fontSize: '14px', textAlign: 'end', display: 'flex', justifyContent: 'end' }}>{formatPrice(getTax())}</span>
                        </div>
                    </div>
                    <div className='d-flex justify-content-between gap-0'>
                        <div className='col p-2' style={{ backgroundColor: '#EAECF0' }}>
                            <span style={{ fontSize: '14px', fontWeight: '600', color: '#667085' }}>Total</span>
                        </div>
                        <div className='col-auto px-2 py-2' style={{ backgroundColor: '#EAECF0' }}>
                            <span style={{ fontSize: '14px', fontWeight: '600', color: '#667085', textAlign: 'end', display: 'flex', justifyContent: 'end' }}>{formatPrice(getTotal())}</span>
                        </div>
                    </div>
                </div>


                <div className='p-2' style={{ borderTop: '1px solid #F4F4F4' }}>
                    <button className='blue-filled-btn d-flex align-items-center w-100' onClick={openReceipt}>
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.83333 1.5V4.33333C4.83333 4.80004 4.83333 5.0334 4.92416 5.21166C5.00406 5.36846 5.13154 5.49594 5.28834 5.57584C5.4666 5.66667 5.69996 5.66667 6.16667 5.66667H11.8333C12.3 5.66667 12.5334 5.66667 12.7117 5.57584C12.8685 5.49594 12.9959 5.36846 13.0758 5.21166C13.1667 5.0334 13.1667 4.80004 13.1667 4.33333V2.33333M13.1667 16.5V11.1667C13.1667 10.7 13.1667 10.4666 13.0758 10.2883C12.9959 10.1315 12.8685 10.0041 12.7117 9.92416C12.5334 9.83333 12.3 9.83333 11.8333 9.83333H6.16667C5.69996 9.83333 5.4666 9.83333 5.28834 9.92416C5.13154 10.0041 5.00406 10.1315 4.92416 10.2883C4.83333 10.4666 4.83333 10.7 4.83333 11.1667V16.5M16.5 6.77124V12.5C16.5 13.9001 16.5 14.6002 16.2275 15.135C15.9878 15.6054 15.6054 15.9878 15.135 16.2275C14.6002 16.5 13.9001 16.5 12.5 16.5H5.5C4.09987 16.5 3.3998 16.5 2.86502 16.2275C2.39462 15.9878 2.01217 15.6054 1.77248 15.135C1.5 14.6002 1.5 13.9001 1.5 12.5V5.5C1.5 4.09987 1.5 3.3998 1.77248 2.86502C2.01217 2.39462 2.39462 2.01217 2.86502 1.77248C3.3998 1.5 4.09987 1.5 5.5 1.5H11.2288C11.6364 1.5 11.8402 1.5 12.0321 1.54605C12.2021 1.58688 12.3647 1.65422 12.5138 1.7456C12.682 1.84867 12.8261 1.9928 13.1144 2.28105L15.719 4.88562C16.0072 5.17387 16.1513 5.318 16.2544 5.48619C16.3458 5.63531 16.4131 5.79789 16.4539 5.96795C16.5 6.15976 16.5 6.36358 16.5 6.77124Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        Pay Now
                    </button>
                </div>
                <div className='d-flex gap-2 align-items-center px-3 py-2 justify-content-between hide-scrollbar' style={{ borderTop: '1px solid #F4F4F4', overflow: 'hidden', maxWidth: '100%' }}>
                    <div className='col' style={{ width: '23%' }}>
                        <button className='large-blue-sq-btn w-100' onClick={() => setIsSelectCustomerOpen(true)}>
                            <svg width="22" height="20" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M26.2144 24.25V21.75C26.2144 19.4202 24.6209 17.4626 22.4644 16.9075M18.0894 2.11345C19.9217 2.85518 21.2144 4.65164 21.2144 6.75C21.2144 8.84836 19.9217 10.6448 18.0894 11.3866M19.9644 24.25C19.9644 21.9203 19.9644 20.7554 19.5838 19.8366C19.0763 18.6114 18.1029 17.6381 16.8778 17.1306C15.9589 16.75 14.7941 16.75 12.4644 16.75H8.71436C6.38465 16.75 5.21979 16.75 4.30094 17.1306C3.0758 17.6381 2.10243 18.6114 1.59496 19.8366C1.21436 20.7554 1.21436 21.9203 1.21436 24.25M15.5894 6.75C15.5894 9.51142 13.3508 11.75 10.5894 11.75C7.82793 11.75 5.58936 9.51142 5.58936 6.75C5.58936 3.98858 7.82793 1.75 10.5894 1.75C13.3508 1.75 15.5894 3.98858 15.5894 6.75Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <div className='btn-text'>
                                Customer Add
                            </div>
                        </button>
                    </div>
                    <div className='col' style={{ width: '23%' }}>
                        <button className='large-blue-outline-sq-btn w-100'>
                            <svg width="22" height="21" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.2675 15.8752L24.3925 2.75022M11.4269 16.2853L14.7121 24.7328C15.0015 25.477 15.1462 25.8491 15.3547 25.9577C15.5354 26.0519 15.7508 26.052 15.9316 25.958C16.1402 25.8497 16.2854 25.4777 16.5757 24.7339L24.8136 3.62421C25.0756 2.95274 25.2066 2.617 25.135 2.40247C25.0727 2.21615 24.9265 2.06994 24.7402 2.0077C24.5257 1.93603 24.1899 2.06705 23.5185 2.32909L2.40879 10.567C1.66495 10.8573 1.29302 11.0024 1.18464 11.2111C1.09068 11.3919 1.0908 11.6072 1.18498 11.788C1.29361 11.9965 1.6657 12.1412 2.40988 12.4306L10.8574 15.7157C11.0084 15.7745 11.084 15.8039 11.1476 15.8492C11.204 15.8894 11.2532 15.9387 11.2935 15.9951C11.3388 16.0587 11.3682 16.1342 11.4269 16.2853Z" stroke="#1643E0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <div className='btn-text'>
                                Send
                            </div>
                        </button>
                    </div>
                    <div className='col' style={{ width: '23%' }}>
                        <button className='large-blue-outline-sq-btn  w-100' onClick={() => openReceipt()}>
                            <svg width="22" height="22" viewBox="0 0 25 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.8213 8.6875C19.339 8.6875 19.7588 8.26776 19.7588 7.75C19.7588 7.23224 19.339 6.8125 18.8213 6.8125V8.6875ZM6.32129 6.8125C5.80353 6.8125 5.38379 7.23224 5.38379 7.75C5.38379 8.26776 5.80353 8.6875 6.32129 8.6875V6.8125ZM18.8213 6.8125H6.32129V8.6875H18.8213V6.8125Z" fill="#1643E0" />
                                <path d="M18.8213 13.6875C19.339 13.6875 19.7588 13.2678 19.7588 12.75C19.7588 12.2322 19.339 11.8125 18.8213 11.8125V13.6875ZM6.32129 11.8125C5.80353 11.8125 5.38379 12.2322 5.38379 12.75C5.38379 13.2678 5.80353 13.6875 6.32129 13.6875V11.8125ZM18.8213 11.8125H6.32129V13.6875H18.8213V11.8125Z" fill="#1643E0" />
                                <path d="M12.5713 18.6875C13.089 18.6875 13.5088 18.2678 13.5088 17.75C13.5088 17.2322 13.089 16.8125 12.5713 16.8125V18.6875ZM6.32129 16.8125C5.80353 16.8125 5.38379 17.2322 5.38379 17.75C5.38379 18.2678 5.80353 18.6875 6.32129 18.6875V16.8125ZM12.5713 16.8125H6.32129V18.6875H12.5713V16.8125Z" fill="#1643E0" />
                                <path d="M3.82129 2.4375H21.3213V0.5625H3.82129V2.4375ZM22.8838 4V22.9429H24.7588V4H22.8838ZM20.792 24.4131L18.8398 23.7103L18.2048 25.4745L20.1569 26.1772L20.792 24.4131ZM16.2649 23.8099L13.2125 25.1834L13.9819 26.8932L17.0343 25.5197L16.2649 23.8099ZM11.93 25.1834L8.87773 23.8099L8.10829 25.5197L11.1607 26.8932L11.93 25.1834ZM6.30275 23.7103L4.35054 24.4131L4.98564 26.1772L6.93784 25.4745L6.30275 23.7103ZM2.25879 22.9429V4H0.383789V22.9429H2.25879ZM4.35054 24.4131C3.33231 24.7796 2.25879 24.0251 2.25879 22.9429H0.383789C0.383789 25.3238 2.74555 26.9836 4.98564 26.1772L4.35054 24.4131ZM8.87773 23.8099C8.06478 23.444 7.14151 23.4084 6.30275 23.7103L6.93784 25.4745C7.3191 25.3371 7.73878 25.3534 8.10829 25.5197L8.87773 23.8099ZM13.2125 25.1834C12.8047 25.3669 12.3379 25.3669 11.93 25.1834L11.1607 26.8932C12.0578 27.297 13.0848 27.297 13.9819 26.8932L13.2125 25.1834ZM18.8398 23.7103C18.001 23.4084 17.0778 23.444 16.2649 23.8099L17.0343 25.5197C17.4038 25.3534 17.8234 25.3371 18.2048 25.4745L18.8398 23.7103ZM22.8838 22.9429C22.8838 24.0251 21.8103 24.7796 20.792 24.4131L20.1569 26.1772C22.397 26.9836 24.7588 25.3238 24.7588 22.9429H22.8838ZM21.3213 2.4375C22.1843 2.4375 22.8838 3.13705 22.8838 4H24.7588C24.7588 2.10153 23.2198 0.5625 21.3213 0.5625V2.4375ZM3.82129 0.5625C1.92281 0.5625 0.383789 2.10153 0.383789 4H2.25879C2.25879 3.13705 2.95834 2.4375 3.82129 2.4375V0.5625Z" fill="#1643E0" />
                            </svg>
                            <div className='btn-text'>
                                Receipt
                            </div>
                        </button>
                    </div>
                    <div className='col' style={{ width: '23%' }}>
                        <button className='large-blue-outline-sq-btn w-100' onClick={openTableActions}>
                            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13 13L24.25 13M13 1.75L13 24.25M7.75 1.75H18.25C20.3502 1.75 21.4003 1.75 22.2025 2.15873C22.9081 2.51825 23.4817 3.09193 23.8413 3.79754C24.25 4.5997 24.25 5.6498 24.25 7.75V18.25C24.25 20.3502 24.25 21.4003 23.8413 22.2025C23.4817 22.9081 22.9081 23.4817 22.2025 23.8413C21.4003 24.25 20.3502 24.25 18.25 24.25H7.75C5.6498 24.25 4.5997 24.25 3.79754 23.8413C3.09193 23.4817 2.51825 22.9081 2.15873 22.2025C1.75 21.4003 1.75 20.3502 1.75 18.25V7.75C1.75 5.6498 1.75 4.5997 2.15873 3.79754C2.51825 3.09193 3.09193 2.51825 3.79754 2.15873C4.5997 1.75 5.6498 1.75 7.75 1.75Z" stroke="#1643E0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <div className='btn-text'>
                                Table actions
                            </div>
                        </button>
                    </div>
                </div>
            </div>

            {
                isReceiptPopupOpen &&
                <>
                    <ReceiptPopup  showProductId={true} isOpen={isReceiptPopupOpen} onBookOnRoom={() => { setIsPutOnRoomOpen(true); }} orderProducts={orderProducts} onClose={() => setIsReceiptPopupOpen(false)} activeOrder={activeOrder} openCashPayment={() => {
                        setIsReceiptPopupOpen(false);
                        setisCashPopupOpen(true);
                    }}
                        openCardPayment={() => {
                            setIsReceiptPopupOpen(false);
                            setisCardPopupOpen(true);
                        }} />
                    <div style={styles.overlay} onClick={() => setIsReceiptPopupOpen(false)}></div>
                </>
            }

            {
                selectedProductToAdd != null &&
                <>
                    {selectedProductToAdd.variants && selectedProductToAdd.variants.length > 0 && isAddVariantOpen &&
                        <AddVariantsPopup product={selectedProductToAdd} onClose={() => setIsAddVariantOpen(false)} onVariantSelected={handleVariantSelected} onNext={handleOnNextInVariant} />
                    }
                    {
                        isAddAddonOpen && selectedProductToAdd.addons && selectedProductToAdd.addons.length > 0 &&
                        <AddAddonsPopup product={selectedProductToAdd} onClose={() => setIsAddAddonOpen(false)} onNext={handleSaveAddons} />
                    }
                    {
                        (isAddAddonOpen || isAddVariantOpen) &&
                        <div style={{ ...styles.overlay, width: windowSize.width, height: windowSize.height }} onClick={handleOverlayClick}></div>
                    }
                </>
            }
            {
                isCashPopupOpen &&
                <>
                    <CashPaymentPopup isOpen={isCashPopupOpen} onClose={() => setisCashPopupOpen(false)} activeOrder={activeOrder} />
                    <div style={{ ...styles.overlay, width: windowSize.width, height: windowSize.height }} onClick={() => setisCashPopupOpen(false)}></div>
                </>
            }

            {
                isCardPopupOpen &&
                <>
                    <CardPaymentPopup isOpen={isCardPopupOpen} onClose={() => setisCardPopupOpen(false)} activeOrder={activeOrder} />
                    <div style={{ ...styles.overlay, width: windowSize.width, height: windowSize.height }} onClick={() => setisCardPopupOpen(false)}></div>
                </>
            }
            {
                isOrderOptionsOpen && optionsOpenedForProductIndex != null &&
                <>
                    <div style={styles.overlay} onClick={handleOverlayClick}></div>
                    <OrderOptionsPopup onTransferProduct={handleTransferProduct} orderProduct={orderProducts[optionsOpenedForProductIndex]} onClose={() => setIsOrderOptionsOpen(false)} onAddDiscount={() => handleSelectedProductAmountDiscount(optionsOpenedForProductIndex)} onAddNote={() => handleAddNoteForProduct(true)} onAddAddon={handleAddAddonForProduct} onAddVariant={handleAddVariantForProduct} />
                </>
            }
            {
                isOrderCombinationsOptionsOpen &&
                <>
                    <div style={{ ...styles.overlay, width: windowSize.width, height: windowSize.height }} onClick={handleOverlayClick}></div>
                    <OrderCombinationOptionsMenu onClose={() => setIsOrderCombinationsOptionsOpen(false)} onAddDiscount={() => handleSelectedAmountDiscountForCombination()} onAddNote={() => handleAddNoteForProduct(false)} />
                </>
            }
            {
                isTableActionsPopupOpen &&
                <>
                    <div style={styles.overlay} onClick={() => setIsTableActionsPopupOpen(false)}></div>
                    <TableActionsPopup onClose={() => setIsTableActionsPopupOpen(false)} onAddDiscount={handleAddDiscount} onChangeTable={handleChangeTables} onMergeTables={handleMergeTables} onDeleteOrder={handleDeleteOrderClick} />
                </>
            }
            {
                showDeleteOrderConfirmation &&
                <>
                    <div className='popup-overlay' onClick={() => setShowDeleteOrderConfirmation(false)}></div>
                    <DeleteConfirmation
                        title='Delete Order'
                        content='Are you sure you want to delete this order? This action cannot be undone.'
                        onClose={() => setShowDeleteOrderConfirmation(false)}
                        onDelete={handleDeleteOrder}
                    />
                </>
            }
            {
                isAddDiscountPopupOpen &&
                <>
                    <div style={styles.overlay} onClick={() => setIsAddDiscountPopupOpen(false)}></div>
                    <AddDiscountPopup onSelectedOrderDiscount={handleSelectedOrderDiscount} onClose={() => setIsAddDiscountPopupOpen(false)} orderProducts={orderProducts} onSelectedProductWithAmount={handleSelectedProductAmountDiscount} />
                </>
            }
            {
                isAddDiscountValuePopupOpen &&
                <>
                    <div style={styles.overlay} onClick={() => closeAddDiscountValuePopup()}></div>
                    <AddDiscountValue onClose={closeAddDiscountValuePopup} product={addingDiscountForProduct} onDiscountSubmit={handleDiscountValueSaved} />
                </>
            }
            {
                (addingNoteForProduct || addingNoteForCombination) &&
                <>
                    <div style={{ ...styles.overlay, width: windowSize.width, height: windowSize.height }} onClick={() => closeAddNoteForProduct()}></div>
                    <AddProductNotePopup existingNote={addingNoteForProduct ? addingNoteForProduct.note : addingNoteForCombination?.note} onClose={() => closeAddNoteForProduct()} onNoteSubmit={handleSaveNote} />
                </>
            }
            {
                addingDiscountForCombination &&
                <>
                    <div style={{ ...styles.overlay, width: windowSize.width, height: windowSize.height }} onClick={() => closeAddDiscountForCombination()}></div>
                    <AddCombinationDiscountPopup onClose={closeAddDiscountForCombination} combination={addingDiscountForCombination} onDiscountSubmit={handleCombinationDiscountValueSaved} />
                </>
            }
            {
                addingAddonForProduct &&
                <>
                    <div style={styles.overlay} onClick={() => closeAddNoteForProduct()}></div>
                    <EditAddonsForProduct onClose={() => closeAddAddonForProduct()} onSave={handleSaveAddonsForProduct} orderProduct={addingAddonForProduct} product={products.find(x => x.id == addingAddonForProduct.product.id)} />
                </>
            }
            {
                addingVariantForProduct &&
                <>
                    <div style={styles.overlay} onClick={() => closeAddVariantForProduct()}></div>
                    <EditVariantsForProduct onClose={() => closeAddVariantForProduct()} onSave={handleSaveVariantForProduct} orderProduct={addingVariantForProduct} product={products.find(x => x.id == addingVariantForProduct.product.id)} />
                </>
            }
            {
                isOrderDiscountOpen &&
                <>
                    <div style={styles.overlay} onClick={() => setisOrderDiscountOpen(false)}></div>
                    <AddOrderDiscountValue onClose={() => setisOrderDiscountOpen(false)} order={activeOrder} onDiscountSubmit={handleSaveOrderDiscountValue} />
                </>
            }
            {
                showVoidedOrderErrorPopup &&
                <VoidedOrderErrorPopup onClose={() => setShowVoidedOrderErrorPopup(false)} />
            }

            {
                isPutOnRoomOpen &&
                <>
                    <SelectReservationPopup onClose={() => setIsPutOnRoomOpen(false)} onConfirmSelection={handleConfirmPutOnRoomSelection} order={activeOrder} />
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(255, 255, 255, 0.6)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9997
                    }}></div>
                </>
            }

            {
                isSelectCustomerOpen &&
                <>
                    <SelectCustomerPopup onClose={() => setIsSelectCustomerOpen(false)} onConfirmSelection={handleConfirmCustomerSelection} order={activeOrder} />
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(255, 255, 255, 0.6)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9997
                    }}></div>
                </>
            }
            {showSuccess && <SuccessNotification headerTitle={successTitle} content={successContent} />}
            {showError && <ErrorNotification headerTitle={errorTitle} content={errorContent} />}
            {showSpinner && (
                <Spinner />
            )}
        </View >
    );
};

export default OrderView;

